import swal from 'sweetalert2'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/pro-light-svg-icons'

import { Button, Form } from '@domain-group/suit-theme'

import handleCallbackAction from '@functions/handleCallbackAction'
import { findStatusByKey } from '@functions/status'

import useStatuses from '@hooks/useStatuses'

import { StatusModel } from '@models/types'

import type { UseFormPayload } from '@domain-group/react-hooks'

type ConfirmUpdateOrderStatusParams = {
  completeStatus: Partial<StatusModel>,
  entityState: UseFormPayload['entityState'],
  bulkStatusUpdateFn: Function,
}

const confirmUpdateOrderStatus = (params: ConfirmUpdateOrderStatusParams) => {
  const { completeStatus, entityState, bulkStatusUpdateFn } = params

  const updateOrderStatusPayload = {
    callbacks: {
      action: bulkStatusUpdateFn,
    },
    entityParams: { ...entityState, status_id: completeStatus?.id },
    toastText: 'Order Marked As Completed',
  }

  swal.fire({
    confirmButtonColor: '#DD6B55',
    confirmButtonText: 'Yes, mark it as completed.',
    icon: 'warning',
    showCancelButton: true,
    text: 'Are you sure?',
    title: 'Mark All Items As Completed?',
  }).then(({ value }) => {
    if (value){
      // @ts-expect-error TS2345
      handleCallbackAction(updateOrderStatusPayload)
    }
  })
}

interface EditOrderStatusProps {
  bulkStatusUpdateFn: Function,
  entityState: UseFormPayload['entityState'],
}

const EditOrderStatus = (props: EditOrderStatusProps) => {
  const { bulkStatusUpdateFn, entityState } = props

  const { filteredStatuses } = useStatuses()
  // @ts-expect-error TS2345
  const completeStatus = findStatusByKey(filteredStatuses, 'complete')

  return (
    <Form.Field label="Mark As" marginTop="large">
      <Button
        buttonStyle="secondaryCreate"
        onClick={() => confirmUpdateOrderStatus({ bulkStatusUpdateFn, completeStatus, entityState })}
        icon={<FontAwesomeIcon icon={faCheckCircle} />}
        size="medium"
      >
        Completed
      </Button>
    </Form.Field>
  )
}

export default EditOrderStatus
